import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  direction: "rtl",
  palette: {
    primary: {
      50: "#FEF4E6",
      100: "#FCDDB1",
      200: "#FACC8B",
      300: "#F8B555",
      400: "#F6A735",
      500: "#F49102", // primary main color
      600: "#DE8402",
      700: "#AD6701",
      800: "#865001",
      900: "#663D01",
    },
    neutral: {
      50: "#F2ECE4",
      100: "#E6E1D8",
      200: "#CDC8C0",
      300: "#B4B0A8",
      400: "#BDBDBD",
      500: "#999591",
      600: "#807D79",
      700: "#4D4B48",
      800: "#343230",
      900: "#1B1A18",
      950: "#0F0E0C",
    },
  },
  mixins: {
    MuiDataGrid: {
      containerBackground: "#FBFAF9",
    },
  },
  typography: {
    fontFamily: "Noto Kufi Arabic, Arial, sans-serif",
    h1: {
      fontSize: "4rem", // 64px
    },
    h2: {
      fontSize: "3rem", // 48px
    },
    h3: {
      fontSize: "2.25rem", // 36px
    },
    h4: {
      fontSize: "1.75rem", // 28px
    },
    h5: {
      fontSize: "1.375rem", // 22px
    },
    h6: {
      fontSize: "1.125rem", // 18px
    },
    body1: {
      fontSize: "1rem", // 16px
    },
    body2: {
      fontSize: "0.875rem", // 14px
    },
    caption: {
      fontSize: "0.75rem", // 12px
    },
    button: {
      fontSize: "1rem", // 16px
      textTransform: "none", // Optional, removes uppercase transform
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF", // Default table background
          borderRadius: "8px",
          border: "1px solid",
          borderColor: "#B4B0A8", // Use neutral[300] directly for the border
          width: "100%", // Full width
          height: "100%",
          overflow: "hidden", // Full height
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: (theme) => theme.palette.neutral[800], // Text color
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#f5f5f5", // Hover effect for rows
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#FBFAF9", // Header background color
        },
      },
    },
    MuiTableFooter: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF", // Footer background (if you want no special background)
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600, // Font weight for the header sort labels
          color: "#865001", // Sorting label text color
        },
      },
    },
  },
});

export default theme;
